import {StatusIndicator} from '@models/machine/status-indicator';

export class ChartConfig {
  cockpit: any; //todo: to define
  statusIndicator: StatusIndicator = new StatusIndicator;
  dashboard: any;
}